import ScopeStackSpinner from "@components/ScopeStackSpinner/ScopeStackSpinner";
import { Routes, Route, Navigate } from "react-router-dom";
import { Edit } from "./Edit/Edit";
import { ServiceAccountNotice } from "./ServiceAccountNotice/ServiceAccountNotice";
import { useAuthorization } from "../../../common/providers/AuthorizationProvider";

const AccountCallbackMspa = (): JSX.Element => {
  const authorized = useAuthorization();
  if (!authorized) {
    return <ScopeStackSpinner />;
  }

  return (
    <Routes>
      <Route path="edit" element={<Edit />} />
      <Route path="new" element={<ServiceAccountNotice />} />
      <Route path="*" element={<Navigate to="edit" replace />} />
    </Routes>
  );
};

export default AccountCallbackMspa;
